import { Err, Ok, object, string } from 'idonttrustlikethat'

const url = string.and(str => {
  try {
    new URL(str)

    return Ok(str)
  } catch (err) {
    return Err(`${str} is not a URL`)
  }
})

const baseValidator = object({
  backendUrl: url,
  frontendUrl: string,
  oktaClientId: string,
  oktaIssuerUrl: string,
  oktaRedirectUri: string
})

export const envValidator = baseValidator

export type AppEnv = typeof envValidator.T
